import { useAuthContext } from 'contexts/AuthContext';
import { ReactElement } from 'react';
import { Navigate } from 'react-router';

interface RoleGuardProps {
  children: ReactElement;
  allowedRoles?: string[];
  allowedAccessTypes?: string[];
}

function RoleGuard(props: RoleGuardProps) {
  const { children, allowedRoles, allowedAccessTypes } = props;
  const { auth } = useAuthContext();

  if (!auth?.token) {
    return <Navigate to="/connexion" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(auth?.user.role || '')) {
    return <Navigate to="/errors/error-404" replace />;
  }

  if (
    allowedAccessTypes &&
    !allowedAccessTypes.includes(auth?.user.accessType || '')
  ) {
    return <Navigate to="/errors/error-404" replace />;
  }

  return children;
}

export default RoleGuard;
